<template>
    <a class="btn rounded" :href="to" :class="{'bg01' : bg01, 'bg02' : bg02, 'comming_soon' : commingsoon, 'multi' : multi }">
        <div v-if="commingsoon" class="comming_soon_cover"></div>
        <div class="btn-inner">
            <span>
                <IconHref class="icon href" v-if="href" />
                <slot />
            </span>
        </div>
        <IconArrow class="icon back" :class="{ 'rotate': more }" />
    </a>
</template>

<script>
import IconArrow from '@/assets/icon-arrow.svg?inline'
import IconHref from '@/assets/icon-href.svg?inline'

export default {
    name: 'btnRounded',
    props:{
        href: Boolean,
        more: Boolean,
        bg01: Boolean,
        bg02: Boolean,
        text: String,
        to: String,
        commingsoon: Boolean,
        multi: Boolean
    },
    components:{
        IconArrow,
        IconHref
    },
    data(){
        return{
            
        }
    },
    methods:{

    },
    mounted(){
        
    }
}
</script>

<style lang="scss" scoped>

$transition: 0.4s;

   .btn.multi .btn-inner {
     justify-content: center;
     text-align: center;
     line-height: 1.6;
     span {
       white-space: pre;
     }
   }
   .btn{
       display: flex;
       justify-content: center;
       align-items: center;
       height: 70px;
       position: relative;
       transition: $transition;
       @media #{$maxM}{
           width: calc(100vw - 40px) !important;
           max-width: 460px !important;
           padding-left: 0 !important;
           padding-right: 0 !important;
       }
       @media #{$IE}{
         padding-top: 30px;
         padding-bottom: 20px;
         box-sizing: border-box;
       }
       .btn-inner{
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: flex-start;
            position: relative;
            width: 100%;
            @media #{$maxM}{
                width: auto;
            }
                span{
                    display: flex;
                    justify-content: flex-start;
                    flex-flow: row nowrap;
                    align-items: center;
                    margin-top: 0.1em;
                    white-space: nowrap;
                    @media #{$maxM}{
                        margin-right: 5px;
                    }
                }
        }
        .icon{
            fill: $white;
            &.back{
                height: 17px;
                width: 10px;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                transition: $transition;
                @media #{$maxM}{
                    width: 8px;
                    height: 10px;
                }
            }
            &.href{
                height: 14px;
                width: 16px;
                margin-right: 16px;
                @media #{$IE}{
                  margin-top: -15px;
                }
            }
        }
        &:hover{
            .icon{
                &.back{
                    transform: translateY(-50%) translateX(6px);
                }
            }
        }

        &.formovie{
            span{
                @media #{$maxM}{
                    font-size: 14px !important;
                    margin-right: 0 !important;
                }
            }
            .icon{
                &.back{
                    @media #{$maxM}{
                        right: 20px !important;
                    }
                }
            }
        }
       //colorsetting
       &.yellow{
           background-color: $yellow;
           color: $white;
           &:hover{
               background-color: rgba($color: $yellow, $alpha: .8);
           }
       }
       &.white{
           background-color: rgba($color: $white, $alpha: 0);
           border: 1px solid $black;
           color: $black;
            .icon{
                fill: $black;
                path{
                    fill: $black !important;
                }
            }
            &:hover{
                background-color: rgba($color: $white, $alpha: 1);
                color: rgba($color: $black, $alpha: .6)
            }
       }
       &.black{
           background-color: $black;
           color: $white;
       }
       &.texture{
            background-image: url('~@/assets/texture.jpg');
            background-repeat: repeat;
            background-size: 100%;  
            background-position: center;
            .icon{
                fill: $black;
                path{
                    fill: $black !important;
                }
            }
            &:hover{
                opacity: 0.7;
            }
       }
       &.bg01{
            background-image: url('~@/assets/page/btn-bg01.jpg');
            background-repeat: no-repeat;
            background-size: cover;  
            background-position: center; 
            color: $white;
            &:hover{
                opacity: 0.8;
            }
       }
       &.bg02{
            background-image: url('~@/assets/page/btn-bg02.jpg');
            background-repeat: no-repeat;
            background-size: cover;  
            background-position: center; 
            color: $white;
            &:hover{
                opacity: 0.8;
            }
       }
        

       //sizesetting
       &.large{
           height: 120px;
           border-radius: 60px;
           @media #{$maxM}{
               height: 84px;
           }
            .icon{
                &.back{
                    right: 50px;
                    @media #{$maxM}{
                        right: 36px;
                    }
                }
            }
       }
       
       &.middle{
           height: 90px;
           border-radius: 45px;
            .icon{
                &.back{
                    right: 45px;
                    @media #{$maxM}{
                        right: 36px;
                    }
                }
            }
       }
       &.small{
           height: 70px;
           border-radius: 35px;
           @media #{$maxM}{
               height: 62px;
           }
           .icon{
                &.back{
                    right: 36px;
                }
            }
       }
       &.multi{
            @media #{$IE}{
              padding-top: 35px;
              padding-bottom: 20px;
              box-sizing: border-box;
            }
            .icon{
                &.back{
                    right: 30px;
                    @media #{$maxM}{
                        right: 36px;
                    }
                }
            }
            &.full {
              .btn-inner {
                font-feature-settings: "palt";
              }
              .icon{
                  &.back{
                      @media #{$maxXS}{
                          right: 18px;
                      }
                  }
              }
            }
       }
       //font-size setting
       &.font-large{
           span{
               font-size: 1.375em;
               @media #{$maxM}{
                   font-size: 1.143em;
               }
           }
       }
       &.font-middle{
           span{
               font-size: 1.125em;
               @media #{$maxM}{
                   font-size: 1em;
               }
           }
       }
       &.comming_soon {
         background-color: $commingsoon;
         pointer-events: none;
         position: relative;
         &:before {
           content: '';
           background-image: url('~@/assets/comingsoon.svg');
           background-repeat: no-repeat;
           background-position: center;
           width: 100%;
           height: 15%;
           display: block;
           position: absolute;
           z-index: 10;
           top: 52%;
           left: 50%;
           transform: translate(-50%, -50%);
           @media #{$maxM}{
             top: 50%;
           }
         }
          .comming_soon_cover {
            opacity: 0.5;
            background: white;
            opacity: 0.5;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 60px;
          }
       }

   }
</style>